// extracted by mini-css-extract-plugin
export default {"animation":"AnimationWrapper_animation__jH-D4","animationInverted":"AnimationWrapper_animationInverted__b1QDU"};